import { render, staticRenderFns } from "./KartaKalendar.vue?vue&type=template&id=08f02142&scoped=true&"
import script from "./KartaKalendar.vue?vue&type=script&lang=js&"
export * from "./KartaKalendar.vue?vue&type=script&lang=js&"
import style0 from "./KartaKalendar.vue?vue&type=style&index=0&id=08f02142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f02142",
  null
  
)

export default component.exports